// extracted by mini-css-extract-plugin
module.exports = {"gridStyle":"modelProgress_gridStyle__LD615","divStyle1":"modelProgress_divStyle1__3BHWR","divStyle2":"modelProgress_divStyle2__1a_sP"};